import { gql } from '@apollo/client';

export const CategoryFragment = gql`
  # eslint-disable-next-line @graphql-eslint/require-id-when-available
  fragment CategoryFragment on CategoryTree {
    uid
    url_key
    name
    adv(currentPage: $currentPage) {
      id
      title
      img
      m_img
      link
      page
      position
    }
  }
`;

export const ProductsFragment = gql`
  fragment ProductsFragment on Products {
    items {
      id
      uid
      name
      serial_name
      product_mark
      show_colorsV1(width: 680, height: 860) {
        label
        rgb
        is_selected
        image
        hover_image
      }
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
      }
      video_url
      prices {
        finalPrice {
          currency
          value
        }
        regularPrice {
          currency
          value
        }
        # ChildrenPrices {
        #     child_product_id
        #     sku
        #     finalPrice {
        #         currency
        #         value
        #     }
        #     regularPrice {
        #         currency
        #         value
        #     }
        # }
      }
      # presale_product {
      #     status
      #     label
      #     note
      # }
      sku
      hover_image(width: 680, height: 860)
      small_image {
        url(type: "thumbnail", width: 680, height: 860)
      }
      stock_status
      rating_summary
      review_count
      __typename
      url_key
      ... on ConfigurableProduct {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        configurable_options {
          attribute_code
          attribute_id
          uid
          label
          product_id
          # eslint-disable-next-line @graphql-eslint/require-id-when-available
          values {
            uid
            default_label
            label
            store_label
            use_default_value
            value_index
            swatch_data {
              ... on ImageSwatchData {
                thumbnail
              }
              value
            }
          }
        }
        # variants {
        #     attributes {
        #         code
        #         value_index
        #     }
        #     # eslint-disable-next-line @graphql-eslint/require-id-when-available
        #     product {
        #         id
        #         uid
        #         presale_product {
        #             status
        #             label
        #             note
        #         }
        #         sku
        #         stock_status
        #     }
        # }
      }
    }
    page_info {
      total_pages
      current_page
    }
    total_count
  }
`;
